import PageTitle from "../components/ui/PageTitle";
import ProjectDescription from "../components/ProjectDescription";

export default function About () {

  return (
    <>
      <PageTitle>About this project</PageTitle>
      <ProjectDescription />
    </>
  );
}
